import React, { Ref } from 'react'

function _IconBuilding(props: React.SVGProps<SVGSVGElement>, ref?: Ref<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <path
        d="M1.61456 7.00521L5.20831 2.8125L8.80206 7.00521"
        stroke="currentColor"
        strokeWidth="1.52"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.61456 18.9844V7.00525H8.80206V18.9844"
        stroke="currentColor"
        strokeWidth="1.52"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3854 18.9843V9.23408C18.3854 9.10832 18.3458 8.98575 18.2723 8.88371C18.1988 8.78167 18.095 8.70533 17.9758 8.66547L11.9862 6.66894C11.8961 6.63876 11.8002 6.63046 11.7062 6.64473C11.6123 6.65899 11.5232 6.69542 11.4461 6.75099C11.3691 6.80656 11.3064 6.87967 11.2633 6.96429C11.2201 7.0489 11.1977 7.14257 11.1979 7.23755V18.9843"
        stroke="currentColor"
        strokeWidth="1.52"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const IconBuilding = React.forwardRef(_IconBuilding)
